import { useState } from 'react';
import './DepartmentPicker.css';

const DepartmentPicker = ({ departments, selectedIds, onChange, disabled, availableIds }) => {
  const [search, setSearch] = useState('');
  const allDepartmentIds = departments.map(d => d.id);

  const sortedDepartments = [...departments].sort((a, b) => a.code.localeCompare(b.code));
  const q = search.toLowerCase();
  const filtered = q
    ? sortedDepartments.filter(d => d.name.toLowerCase().includes(q) || d.code.includes(q))
    : sortedDepartments;

  const isAvailable = (id) => !availableIds || availableIds.length === 0 || availableIds.includes(id);

  const toggleDept = (deptId) => {
    if (disabled || !isAvailable(deptId)) return;
    const next = selectedIds.includes(deptId)
      ? selectedIds.filter(id => id !== deptId)
      : [...selectedIds, deptId];
    onChange(next);
  };

  const selectAll  = () => { if (disabled) return; onChange(availableIds?.length ? availableIds : allDepartmentIds); };
  const selectNone = () => { if (disabled) return; onChange([]); };
  const totalSelected = selectedIds.length;

  return (
    <div className={`arm-dept-picker${disabled ? ' arm-dept-picker--disabled' : ''}`}>
      <div className="arm-dept-toolbar">
        <div className="arm-dept-search-wrap">
          <input
            type="text"
            className="arm-dept-search"
            placeholder="Rechercher un département…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            disabled={disabled}
          />
          {search && <button type="button" className="arm-dept-search-clear" onClick={() => setSearch('')}>✕</button>}
        </div>
        <div className="arm-dept-actions">
          {totalSelected > 0 && <span className="arm-dept-total-badge">{totalSelected} sél.</span>}
          <button type="button" className="arm-dept-action-btn" onClick={selectAll}  disabled={disabled}>Tout</button>
          <button type="button" className="arm-dept-action-btn" onClick={selectNone} disabled={disabled}>Aucun</button>
        </div>
      </div>

      <div className="arm-dept-chips-list">
        {filtered.map((dept) => {
          const active    = selectedIds.includes(dept.id);
          const available = isAvailable(dept.id);
          return (
            <button
              type="button"
              key={dept.id}
              className={[
                'arm-dept-chip',
                active     ? 'arm-dept-chip--active'      : '',
                !available ? 'arm-dept-chip--unavailable' : '',
              ].filter(Boolean).join(' ')}
              onClick={() => toggleDept(dept.id)}
              disabled={disabled || !available}
              title={!available ? 'Non disponible pour cet utilisateur' : dept.name}
            >
              <span className="arm-dept-chip-code">{dept.code}</span>
              <span className="arm-dept-chip-name">{dept.name}</span>
            </button>
          );
        })}
      </div>

      {filtered.length === 0 && (
        <div className="arm-dept-empty">Aucun département trouvé pour «&nbsp;{search}&nbsp;»</div>
      )}
    </div>
  );
};

export default DepartmentPicker;